<div class="row">
  <app-select
    [attribute]="getSelectElement()"
    [class]="getSizeClass(getSelectElement())"
    [envOptions]="envOptions"
    (onEmit)="onChangedSelect($event)">
  </app-select>

  <app-dynamic *ngFor="let contentItem of selectedContentAttrs" 
      [class]="getSizeClass(contentItem)" 
      [attribute]="contentItem"
      [envOptions]="envOptions" 
      [parent]="attribute"
      (onEmit)="handleEvent($event)">
  </app-dynamic>
</div>